import React from 'react';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import { Query } from '@apollo/react-components';
import { gql } from '@apollo/client';
import moment from 'moment';
import numeral from 'numeral';
import NotFound from '$components/NotFound';
import SpinnerError from '$components/library/SpinnerError';
import styles from './styles.scss';

const StudyReportQuery = gql`
  query UserExamsStudyReport($input: StudyReportInput!) {
    userExamsStudyReport(input: $input) {
      userExams {
        uuid
        exam {
          uuid
          allottedTimeMins
          numQuestions
          product {
            uuid
            name
          }
        }
        finishedAt
        points
        pointsTotal
        score
        startedAt
        status
        variant
      }
    }
  }
`;

const StudyReportExam = (props) => {
  const { duration, points, pointsTotal, score, status } = props;

  return (
    <li className={styles.exam}>
      <div>STATUS: {status}</div>
      <div>
        SCORE: {score} ({points}/{pointsTotal})
      </div>
      {duration && <div>DURATION: {duration}</div>}
    </li>
  );
};

const StudyReport = () => {
  const { userUuid, productSlug } = useParams();

  return (
    <Query query={StudyReportQuery} variables={{ input: { productSlug, userUuid } }}>
      {({ loading, error, data }) => {
        if (loading || error) {
          return <SpinnerError error={error} />;
        }

        const {
          userExamsStudyReport: { userExams },
        } = data;

        if (!userExams) return <NotFound />;

        const sortedUserExams = _.sortBy(userExams, 'finishedAt');

        const {
          exam: {
            product: { name },
            allottedTimeMins,
            numQuestions,
          },
        } = userExams[0];

        return (
          <div>
            <h1>Study Report Page</h1>
            <h2>{name}</h2>
            <p>
              {numQuestions} questions | {allottedTimeMins} minutes
            </p>
            <ul className={styles.examsList}>
              {sortedUserExams.map((userExam) => {
                const {
                  finishedAt,
                  points,
                  pointsTotal,
                  score,
                  startedAt,
                  status,
                  uuid,
                } = userExam;
                const formattedScore = numeral(score).format('0%');
                const duration = finishedAt
                  ? moment.duration(finishedAt - startedAt).humanize()
                  : null;

                return (
                  <StudyReportExam
                    key={uuid}
                    duration={duration}
                    points={points}
                    pointsTotal={pointsTotal}
                    score={formattedScore}
                    status={status}
                  />
                );
              })}
            </ul>
          </div>
        );
      }}
    </Query>
  );
};

export default StudyReport;
